module.exports = __webpack_public_path__ + "static/taofeek-eb43cf917c1a60a72af331b564002d25.jpg";